var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.25 18.3333H28.9167M37.25 24.5833H28.9167M24.75 31.875C24.1592 29.4977 21.5854 27.7083 18.5 27.7083C15.4146 27.7083 12.8409 29.4977 12.25 31.875M12.6667 39.1667H36.8333C39.1669 39.1667 40.3338 39.1667 41.225 38.7125C42.009 38.3131 42.6465 37.6756 43.0458 36.8917C43.5 36.0004 43.5 34.8335 43.5 32.5V16.6667C43.5 14.3331 43.5 13.1663 43.0458 12.275C42.6465 11.491 42.009 10.8536 41.225 10.4541C40.3338 10 39.1669 10 36.8333 10H12.6667C10.3331 10 9.16633 10 8.27504 10.4541C7.49102 10.8536 6.8536 11.491 6.45415 12.275C6 13.1663 6 14.3331 6 16.6667V32.5C6 34.8335 6 36.0004 6.45415 36.8917C6.8536 37.6756 7.49102 38.3131 8.27504 38.7125C9.16633 39.1667 10.3331 39.1667 12.6667 39.1667ZM20.5833 19.375C20.5833 20.5256 19.6506 21.4583 18.5 21.4583C17.3494 21.4583 16.4167 20.5256 16.4167 19.375C16.4167 18.2244 17.3494 17.2917 18.5 17.2917C19.6506 17.2917 20.5833 18.2244 20.5833 19.375Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 19.5,
    r: 1.5,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.cf53fa36.svg";
export { ForwardRef as ReactComponent };